module.exports = __webpack_public_path__ + "img/vehicle-options-white-kia.cb2f2c79.png";